import {
  createApi,
  fetchBaseQuery,
  type FetchArgs,
  type BaseQueryFn,
  type FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'
import { mutex } from '@/store'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const baseQuery = async (args: any, api: any, extraOptions: any) => {
  const { getState } = api
  const state = getState()
  return fetchBaseQuery({
    baseUrl: state.app.baseUrl,
    credentials: 'include',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('accessToken')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  })(args, api, extraOptions)
}

const getBaseQueryWithRefresh = (
  baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  return async (args, api, extraOptions) => {
    await mutex.waitForUnlock()
    let result = await baseQuery(args, api, extraOptions)

    if (
      result.error &&
      (result.error.status === 401 || result.error.data === 'Unauthorized')
    ) {
      if (!mutex.isLocked()) {
        const release = await mutex.acquire()
        try {
          const token = localStorage.getItem('accessToken')
          if (!token) {
            window.location.reload()
          }

          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const refresh: any = (
            await baseQuery(
              { url: '/web/auth/refresh', method: 'POST' },
              api,
              extraOptions
            )
          )?.data

          if (refresh?.access_token) {
            localStorage.setItem('accessToken', refresh.access_token)
            result = await baseQuery(args, api, extraOptions)
          } else {
            localStorage.removeItem('accessToken')
            localStorage.removeItem('refreshToken')
            window.location.reload()
          }
        } finally {
          release()
        }
      } else {
        await mutex.waitForUnlock()
        result = await baseQuery(args, api, extraOptions)
      }
    }
    return result
  }
}

export const apiReports = createApi({
  reducerPath: 'apiReports',
  keepUnusedDataFor: 60 * 60,
  refetchOnFocus: true,
  baseQuery: getBaseQueryWithRefresh(baseQuery),
  endpoints: () => ({}),
})
